module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-teenagers-fbf2bd5c1d5d7a33655e04d571cdb653.webp";